import React, {Component} from 'react'
import {Row, Col} from 'react-bootstrap';
import {FaHome, FaMale} from 'react-icons/fa';
import {FooterContainer, FooterCopyright,FooterSMDiv,FooterMobile,FooterBodyMobile} from '../../theme/MorsTheme';
import {RESPONSE} from '../../resources/constant';
import dateFormat from 'dateformat';
//var dateFormat = require('dateformat');

export default class Footer extends Component{
	
	constructor(props){
		super(props);
		this.state = {
			cu:JSON.parse(localStorage.getItem(RESPONSE))
		};   				
	}

    render(){
        return (
			<div>
				<div>
					<Row style={{fontSize:'12px', fontWeight:'bold'}} xs={12}>				
						<Col md={4} xs={4}>User ID : <span style={{color: '#0B2972'}}>{this.state.cu.user.loginName}</span></Col>
						<Col md={4} xs={4}>Group Name : <span style={{color: '#0B2972'}}>{this.state.cu.user.groupName}</span></Col>
						<Col md={4} xs={4}>Current Date : <span style={{color: '#0B2972'}}>{dateFormat(new Date(), 'yyyy-mm-dd')}</span></Col>				
					</Row>
					
				</div>
				<Row className="d-none d-sm-block">
	 			<FooterContainer>
	            	<div>
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/about-bdo/business-operation">About BDO</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/corporate-governance">Corporate Governance</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/investor-relations/investment-credit-ratings-information">Investor Relations</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/contact-us">Contact Us</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/careers">Careers</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/news-and-articles">Press Room</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/site-map">Site Map</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/privacy-policy">Privacy Policy</a>												
						<a style={{color:'#999', padding:'10px'}} href="https://www.bdo.com.ph/terms-and-conditions">Terms and Conditions</a>												
                	</div>
                	<FooterCopyright>
                		BDO Unibank, Inc. © 2015. All Rights Reserved
                	</FooterCopyright>    
        		</FooterContainer>
				</Row>

				<Row className="d-block d-sm-none">
				<Col xs={12} sm={12}>
				<FooterSMDiv>
					<Row>
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>               
							<a href="http://www.bdo.com.ph/personal" style={{padding:'10px'}}>
								<span style={{color:'white'}}><FaHome/> Home</span>                        
							</a>                       
						</Col>                    
						<Col style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/business" style={{padding:'10px'}}>
								<span style={{color:'white'}}><FaMale/>Business Banking</span>                        
							</a>        
						</Col>
					</Row>
					<Row>     
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/mobile/about-bdo">
								<span style={{color:'white'}}>About</span>                        
							</a>                        
						</Col>           
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/mobile/contact-us">
								<span style={{color:'white'}}>Contact</span>                        
							</a>                 
						</Col>           
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/mobile/terms-and-conditions">
								<span style={{color:'white'}}>Terms</span>                        
							</a>                 
						</Col>           
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/mobile/privacy-policy">
								<span style={{color:'white'}}>Privacy</span>                        
							</a>                 
						</Col>
					</Row>
					<Row> 
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>                    
							<span style={{color:'white'}}>Desktop View</span>                                            
						</Col>               
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<a href="https://www.bdo.com.ph/mobile/forex">
								<span style={{color:'white'}}>FOREX</span>                        
							</a>                 
						</Col>
					</Row>
					<Row> 
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>                    
							<a href="https://www.bdo.com.ph/mobile/personal/investments/daily-net-asset-value">
								<span style={{color:'white'}}>Daily NAVPU</span>                        
							</a>  
						</Col>               
						<Col as={Col} style={{border:'1px solid white', borderRight: '1px solid white'}}>
							<span style={{color:'white'}}>
							BDO Unibank © 2015    
							</span>               
							
						</Col>                               
					</Row>            
				</FooterSMDiv>
				</Col>
				</Row>
				{/* <div>
				<Row className="d-block d-sm-none" >
					
					<FooterBodyMobile>

					<Row style={{background:'#848484'}}>
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
						<a href="https://www.bdo.com.ph/business">&nbsp;&nbsp;&nbsp;&nbsp;
							<img src="media/images/home-icon.png" />&nbsp;&nbsp;Home
						</a>
					</Col>
					
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
						<a href="https://www.bdo.com.ph/business">
							<img src="media/images/business-icon.png" />&nbsp;&nbsp;Business Banking
						</a>
					</Col>
					</Row>

					<Row style={{background:'#848484'}}>
					<Col class="col-xs-3" style={{border:'1px solid white',}}>
						<a href="https://www.bdo.com.ph/mobile/about-bdo">
							About
						</a>
					</Col>
					<Col class="col-xs-3" style={{border:'1px solid white'}}>
						<a href="https://www.bdo.com.ph/mobile/contact-us">
							Contact
						</a>
					</Col>
					<Col class="col-xs-3" style={{border:'1px solid white'}}>
						<a href="https://www.bdo.com.ph/mobile/terms-and-conditions">
							Terms
						</a>
					</Col>

					<Col class="col-xs-3" style={{border:'1px solid white'}}>
					<a href="https://www.bdo.com.ph/mobile/privacy-policy">
						Privacy
					</a>
					</Col>
					</Row>
					
					<Row style={{background:'#848484'}}>
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
						<img src="media/images/monitor-icon.png" />&nbsp;&nbsp;Desktop View
					</Col>
					
					
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
					<a href="https://www.bdo.com.ph/mobile/forex">
						FOREX
					</a>
					</Col>
					</Row>

					<Row style={{background:'#848484'}}>
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
					<a href="https://www.bdo.com.ph/mobile/personal/investments/daily-net-asset-value">
						Daily NAVPU
					</a>
					</Col>
					<Col class="col-xs-6" style={{border:'1px solid white'}}>
						BDO Unibank © 2015
					</Col>
					</Row>
					</FooterBodyMobile>
					
				</Row>  
				</div> */}
			</div>
        )
    }
}